/* ============================================================
   BLAZIN SAUNAS — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── SCROLL REVEAL ─────────────────────────────────────── */
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('visible'); revealObserver.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

  /* ── NAV SCROLL ────────────────────────────────────────── */
  const header = document.getElementById('site-header');
  if (header) {
    const update = () => header.classList.toggle('scrolled', window.scrollY > 60);
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ── MOBILE MENU ───────────────────────────────────────── */
  const toggle = document.getElementById('mobile-menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileClose = document.getElementById('mobile-nav-close');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => mobileNav.classList.add('open'));
    mobileClose && mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'));
    mobileNav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mobileNav.classList.remove('open')));
  }

  /* ── CART DRAWER ───────────────────────────────────────── */
  const cartBtns  = document.querySelectorAll('[data-open-cart]');
  const cartClose = document.getElementById('cart-close');
  const cartBg    = document.getElementById('cart-bg');
  const cartDrawer = document.getElementById('cart-drawer');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    document.getElementById('cart-bg').classList.add('active');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    document.getElementById('cart-bg').classList.remove('active');
    document.body.style.overflow = '';
  }
  cartBtns.forEach(b => b.addEventListener('click', openCart));
  cartClose && cartClose.addEventListener('click', closeCart);
  cartBg && cartBg.addEventListener('click', closeCart);

  function fetchCart() {
    const body = document.getElementById('cart-items');
    const total = document.getElementById('cart-total-price');
    if (!body) return;
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        if (cart.items.length === 0) {
          body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
          return;
        }
        body.innerHTML = cart.items.map(item => `
          <div class="cart-item">
            <img class="cart-item-img" src="${item.image}" alt="${item.title}">
            <div class="cart-item-info">
              <p class="cart-item-title">${item.title}</p>
              <p class="cart-item-price">${formatMoney(item.final_price)}</p>
              <p class="body-sm">Qty: ${item.quantity}</p>
            </div>
          </div>`).join('');
        if (total) total.textContent = formatMoney(cart.total_price);
      });
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── ADD TO CART ───────────────────────────────────────── */
  const addToCartForm = document.getElementById('add-to-cart-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = this.querySelector('.add-to-cart-btn');
      btn.textContent = 'Adding…';
      btn.disabled = true;
      const formData = new FormData(this);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json())
        .then(() => {
          btn.textContent = 'Added!';
          setTimeout(() => { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1800);
          fetchCart();
          openCart();
        })
        .catch(() => { btn.textContent = 'Add to Cart'; btn.disabled = false; });
    });
  }

  /* ── QUANTITY SELECTOR ─────────────────────────────────── */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.quantity-selector').querySelector('.qty-input');
      const v = parseInt(input.value) || 1;
      if (btn.dataset.action === 'minus') input.value = Math.max(1, v - 1);
      if (btn.dataset.action === 'plus') input.value = v + 1;
    });
  });

  /* ── PRODUCT VARIANT BUTTONS ───────────────────────────── */
  const variantDataEl = document.getElementById('variant-data');
  if (variantDataEl) {
    let variants = [];
    try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { variants = []; }
    const variantIdInput = document.getElementById('variant-id');
    const priceEl = document.getElementById('product-price');
    const addBtn = document.querySelector('.add-to-cart-btn');
    const groups = document.querySelectorAll('.option-group');

    // Build the currently selected option set
    function getSelected() {
      const selected = [];
      groups.forEach(group => {
        const active = group.querySelector('.option-btn.active');
        selected.push(active ? active.dataset.value : null);
      });
      return selected;
    }

    function matchVariant(selected) {
      return variants.find(v => selected.every((val, i) => v.options[i] === val));
    }

    function updateVariant() {
      const selected = getSelected();
      const match = matchVariant(selected);
      if (match) {
        if (variantIdInput) variantIdInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
      }
    }

    document.querySelectorAll('.option-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.closest('.option-values').querySelectorAll('.option-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        updateVariant();
      });
    });

    // Ensure something is selected on load
    groups.forEach(group => {
      if (!group.querySelector('.option-btn.active')) {
        const first = group.querySelector('.option-btn');
        if (first) first.classList.add('active');
      }
    });
    updateVariant();
  }

  /* ── PRODUCT GALLERY ───────────────────────────────────── */
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const mainImg = document.getElementById('gallery-main-img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.dataset.full;
    });
  });

  /* ── PRODUCT TABS ──────────────────────────────────────── */
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.product-tabs');
      group.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      group.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      group.querySelector(`#${btn.dataset.tab}`).classList.add('active');
    });
  });

  /* ── BENEFITS TOC ACTIVE STATE ─────────────────────────── */
  const tocLinks = document.querySelectorAll('.toc-link');
  if (tocLinks.length) {
    const sections = Array.from(tocLinks).map(l => document.querySelector(l.getAttribute('href')));
    const tocObserver = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          tocLinks.forEach(l => l.classList.remove('active'));
          const active = document.querySelector(`.toc-link[href="#${e.target.id}"]`);
          if (active) active.classList.add('active');
        }
      });
    }, { rootMargin: '-20% 0px -60% 0px' });
    sections.forEach(s => s && tocObserver.observe(s));
  }

  /* ── SMOOTH ANCHOR SCROLL ──────────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* ── CONTACT FORM (SHOPIFY NATIVE) ────────────────────── */
  const contactForm = document.getElementById('contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function () {
      const btn = this.querySelector('[type="submit"]');
      if (btn) { btn.textContent = 'Sending…'; btn.disabled = true; }
    });
  }

})();
